export const PARENT_PRODUCTS = {
	CONFLUENCE: 'confluence',
	HOME: 'home',
	JIRA: 'jira',
	TEAMS: 'teams',
} as const;

export interface PanelDataMap {
	actions?: {
		onClose: () => void;
		onExpand: () => void;
		onOpenInNewTab?: () => void;
		onPublish?: () => void;
	};
	embedUrl?: string;
}
